import React from "react";
import TestimonialCard from "../cards/testimonials";
import Slider from "../common/Slider";
import { getSliderSettings } from "./recentJobGroup";
import { MessageSquareQuote } from "lucide-react";

interface TestimonialItem {
  id: number | string;
  name: string;
  position: string;
  message: string;
  get_image_url: string;
}

interface TestimonialGroupProps {
  testimonialList: TestimonialItem[];
}

function TeastimonialGroup({ testimonialList }: TestimonialGroupProps) {
  if (!Array.isArray(testimonialList) || testimonialList.length === 0) {
    return null;
  }

  const settings = getSliderSettings({
    dots: true,
    arrows: true,
    slidesToShow: 1,
    removeAutoPlay: false,
    slidesToShowAt1024Breakpoint: 1,
    slidesToShowAt992Breakpoint: 1,
    objectCount: testimonialList.length,
    speed: 500,
    autoplaySpeed: 20000,
  });

  return (
    <section className="cht-py-14 sm:cht-py-20 cht-bg-[#f8fafc]/50 cht-border-y cht-border-slate-200/80 !cht-font-body">
      <div className="cht-max-w-5xl cht-mx-auto cht-px-4 sm:cht-px-6 lg:cht-px-8">
        <header className="cht-text-center cht-max-w-2xl cht-mx-auto cht-mb-12 sm:cht-mb-16">
          <div className="cht-inline-flex cht-items-center cht-gap-2 cht-px-3.5 cht-py-1.5 cht-bg-blue-50 cht-border cht-border-blue-100 cht-rounded-full cht-text-xs !cht-font-bold cht-text-[#3e57da] cht-mb-4">
            <MessageSquareQuote size={14} />
            <span>Client & Student Stories</span>
          </div>

          <h2 className="!cht-font-heading cht-text-2xl sm:cht-text-3xl md:cht-text-4xl !cht-font-extrabold cht-text-[#1e293b] cht-tracking-tight cht-mb-3">
            What Our Partners & Learners Say
          </h2>

          <p className="!cht-font-body cht-text-sm sm:cht-text-base cht-text-slate-600 cht-leading-relaxed">
            Real feedback from enterprises we’ve delivered solutions for and graduates flourishing in their tech careers.
          </p>
        </header>

        <div className="cht-px-2">
          <Slider {...settings}>
            {testimonialList.map((item) => (
              <TestimonialCard
                key={item.id}
                image={item.get_image_url}
                id={item.id}
                name={item.name}
                position={item.position}
                message={item.message}
              />
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
}

export default TeastimonialGroup;

